import 'focus-visible';
import Event from '../../event/js/module';
import KeyboardEvent from '../../event/js/keyboard';

// constants
const ARIA_EXPANDED_ATTR = 'aria-expanded';
const ARIA_LABELLEDBY_ATTR = 'aria-labelledby';
const DISPLAY_NONE_CLASS = 'at-d-none';
const COLLAPSING_CLASS = '.delayed-collapsing';
const EXPANDED_ACCORDION_CLASS = 'at-universal-accordion--expanded';

// this function is used to trigger a resize event to render components within an accordion item correctly
const triggerResizeEvent = (timeout = 200) => {
  setTimeout(() => {
    const resizeEvent = document.createEvent('HTMLEvents');
    resizeEvent.initEvent('resize', true, false);
    window.dispatchEvent(resizeEvent);
  }, timeout);
};

const initAccordion = (element = 'accordion', showAllElement = 'accordion-show-hide-all-btn') => {
  window.onload = () => {
    const accordionItemsToCollapse = document.querySelectorAll(COLLAPSING_CLASS);
    if (!accordionItemsToCollapse) {
      return;
    }

    accordionItemsToCollapse.forEach((item) => {
      const accordionId = item.getAttribute(ARIA_LABELLEDBY_ATTR);
      const relatedHeader = document.querySelector(`#${accordionId}`);
      const isExpanded = relatedHeader.getAttribute(ARIA_EXPANDED_ATTR) === 'true';

      if (isExpanded) {
        return;
      }

      setTimeout(() => {
        item.classList.add(DISPLAY_NONE_CLASS);
        relatedHeader.setAttribute(ARIA_EXPANDED_ATTR, false);
      }, 200);
    });
  };

  Event.eventHandler(
    showAllElement,
    'click',
    (buttonElement, _, event) => {
      event.preventDefault();

      const isExpanded = buttonElement.innerText === 'Hide all';

      const accordionBtnSelector = `[data-element="${element}"]`;
      const parentElement = buttonElement.parentElement.parentElement;

      parentElement.querySelectorAll(accordionBtnSelector).forEach((accordionBtn) => {
        const relatedPanel = document.querySelector(accordionBtn.getAttribute(`data-${element}-target`));

        accordionBtn.setAttribute(ARIA_EXPANDED_ATTR, !isExpanded);

        if (isExpanded) {
          relatedPanel.classList.add(DISPLAY_NONE_CLASS);
          accordionBtn.classList.remove(EXPANDED_ACCORDION_CLASS);
          const button = buttonElement;
          button.innerText = 'Show all';
        } else {
          relatedPanel.classList.remove(DISPLAY_NONE_CLASS);
          accordionBtn.classList.add(EXPANDED_ACCORDION_CLASS);
          const button = buttonElement;
          button.innerText = 'Hide all';
          triggerResizeEvent();
        }
      });
    },
  );

  Event.eventHandler(element, 'click', (buttonElement, panelElement, event) => {
    event.preventDefault();

    const isExpanded = buttonElement.getAttribute('aria-expanded') === 'true';

    buttonElement.setAttribute('aria-expanded', !isExpanded);

    if (isExpanded) {
      panelElement.classList.add('at-d-none');
      buttonElement.classList.remove('at-universal-accordion--expanded');
    } else {
      panelElement.classList.remove('at-d-none');
      buttonElement.classList.add('at-universal-accordion--expanded');
      triggerResizeEvent();
    }
  });

  Event.eventHandler(
    element,
    'keydown',
    (buttonElement, panelElement, event) => {
      switch (true) {
        case KeyboardEvent.CheckKey(event, KeyboardEvent.Key.UP):
          event.preventDefault();
          event.stopPropagation();

          buttonElement.parentElement.previousElementSibling?.previousElementSibling?.firstElementChild.focus();
          break;
        case KeyboardEvent.CheckKey(event, KeyboardEvent.Key.DOWN):
          event.preventDefault();
          event.stopPropagation();

          panelElement?.nextElementSibling?.firstElementChild.focus();
          break;
        default:
          break;
      }
    },
  );
};

export default initAccordion;
